// index.js or App.js
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import ReactDOM from 'react-dom/client';
import App from './App';

const theme = extendTheme({
  colors: {
    customOrange: '#FF684B',
  },
  styles: {
    global: {
      // Стили для всего приложения
      body: {
        bg: '#fff8f3', // Фон для body
        color: 'black', // Цвет текста для body (опционально)
        fontFamily: 'Arial, sans-serif', // Шрифт (опционально)
      },
    },
  },
  components: {
    Button: {
      sizes: {
        smd: { // Custom size
          fontSize: "sm", // Adjust font size
          px: 4, // Adjust padding
          py: 2,
        },
      },
      variants: {
        custom: {
          bg: 'customOrange',
          color: 'white',
          _hover: {
            bg: 'orange.600',
          },
        },
      },
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>
);
